import { useMediaQuery, useTheme } from '@material-ui/core';

interface IUseDeviceSizeType {
  isMobile: boolean;
  isDesktop: boolean;
  isTablet: boolean;
}

export const useDeviceSizeType = (): IUseDeviceSizeType => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const isTablet = useMediaQuery(
    () =>
      `(min-width:${theme.breakpoints.values.md}px) and (max-width:${theme.breakpoints.values.lg}px)`,
  );

  return {
    isMobile,
    isDesktop,
    isTablet,
  };
};
